export default "__VITE_ASSET__DAEe$1JV__"